<template>
  <card>
    <list
      v-if="$store.state.user.sections['shops']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setImport="true"
      :setLink="setLink"
      :exportFields="exportFields"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        ID: {
          field: "id",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return val;
            }
          },
        },
        Название: {
          field: "name",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return val;
            }
          },
        },
        Адрес: {
          field: "address",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return val;
            }
          },
        },

        "Город/район": {
          field: "location",
          callback: (val) => {
            try {
              return val.title;
            } catch (error) {}
          },
        },
        Регион: {
          field: "location.location",
          callback: (val) => {
            try {
              return val.title;
            } catch (error) {}
          },
        },
        Орагинзации: {
          field: "organizations",
          callback: (val) => {
            let organizations = [];

            try {
              for (let i = 0; i < val.length; i++) {
                organizations.push(val[i].name);
              }
            } catch (error) {}

            return organizations.join(", ");
          },
        },
        "Фин. партнеры": {
          field: "partners",
          callback: (val) => {
            let partners = [];

            try {
              for (let i = 0; i < val.length; i++) {
                partners.push(val[i].name);
              }
            } catch (error) {}

            return partners.join(", ");
          },
        },
      },
      params: {},
      val: [],
      modalCreate: "season",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "organizations",
          label: "Холдинги",
          type: "selects",
          modal: "organization",
          selectKey: "name",
        },
        {
          col: " col-12 col-md-8",
          key: "name",
          label: "Название магазина",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-4",
          label: "Компания",
          key: "dealer",
          type: "select",
          modal: "dealer",
          selectKey: "name",
        },
        {
          col: " col-12 col-md-12",
          key: "location_id",
          label: "Регион / город",
          type: "location",
        },
        {
          col: " col-12 col-md-12",
          key: "address",
          labelKey: "address",
          label: "Адрес магазина",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "coords",
          label: "Отиетка на карте",
          type: "map",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_shop",
      itemLink: "shops",
      setLink: "shops",
      columns: [
        {
          detail: true,
        },
        {
          key: "id",
          title: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "name",
          title: "Название магазина",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "address",
          title: "Адрес",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          full: true,
        },
        {
          key: "location",
          object: "title",
          title: "Регион / город",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "dealer",
          object: "name",
          title: "Компания",
          // disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "partners",
          object: "name",
          title: "Разрешенные",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          full: true,
          detail: false,
        },
        {
          key: "systems",
          object: "key",
          title: "Синхронизация с системой",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
